import { useTranslation } from 'react-i18next'
import { useDensity, type Density } from '@/shared/hooks/useDensity'
import { SegmentedControl, type SegmentedOption } from './SegmentedControl'

/** Bascule de densité (compact/standard/confort) - préférence profil, DESIGN §2. */
export function DensityToggle({ className }: { className?: string }) {
  const { t } = useTranslation()
  const { density, setDensity } = useDensity()

  const options: SegmentedOption<Density>[] = [
    { value: 'compact', label: t('shared.appearance.density.compact') },
    { value: 'default', label: t('shared.appearance.density.default') },
    { value: 'comfy', label: t('shared.appearance.density.comfy') },
  ]

  return (
    <SegmentedControl
      options={options}
      value={density}
      onChange={setDensity}
      ariaLabel={t('shared.appearance.density.label')}
      className={className}
    />
  )
}
